module.exports = __webpack_public_path__ + "img/AS.35bca85b.png";